"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M22.01 4.05 20.6 3.4l-.65-1.41c-.18-.39-.73-.39-.91 0L18.4 3.4l-1.41.65c-.39.18-.39.73 0 .91l1.41.64.65 1.41c.18.39.73.39.91 0l.64-1.41 1.41-.65c.39-.17.39-.73 0-.9"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "13",
  r: "1.25"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "13",
  r: "1.25"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M19.5 8.8c-.78 0-1.49-.46-1.82-1.17l-.41-.9-.9-.41c-.71-.33-1.17-1.04-1.17-1.82 0-.66.34-1.26.87-1.63C14.83 2.32 13.45 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.45-.32-2.83-.87-4.07-.37.53-.97.87-1.63.87M12 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14 2.6-.98 4.69-2.99 5.74-5.55C11.58 8.56 14.37 10 17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8"
}, "3")], 'FaceRetouchingNaturalRounded');